/**
 * Dialog wrapper para criação de Template WhatsApp
 * Redireciona para o CreateTemplateWizard com layout de 3 colunas
 */

import { CreateTemplateWizard } from './CreateTemplateWizard';

interface OfficialInbox {
  id: string;
  name: string;
  identifier: string;
  provider_id?: string;
  provider_slug?: string;
  provider_name?: string;
}

interface CreateTemplateDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  inboxes: OfficialInbox[];
  onSuccess: () => void;
}

/**
 * Componente wrapper que renderiza o wizard de criação
 * Mantido para compatibilidade com código existente
 */
export function CreateTemplateDialog(props: CreateTemplateDialogProps) {
  return <CreateTemplateWizard {...props} />;
}
